import * as React from 'react';

export function useShare(shareUrl: string) {
  const [canShare, setCanShare] = React.useState(false);

  const shareData = React.useMemo(() => {
    return { url: shareUrl };
  }, [shareUrl]);

  const share = React.useCallback(async () => {
    try {
      if (navigator && navigator.share) {
        await navigator.share(shareData);
      }
    } catch (e) {
      console.error(e);
    }
  }, [shareData]);

  React.useEffect(() => {
    if (navigator && navigator.canShare(shareData)) {
      setCanShare(true);
    } else {
      setCanShare(false);
    }
  }, [shareData]);

  return { canShare, share };
}
